var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "444pt",
    viewBox: "-96 0 444 444",
    width: "444pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 68.398438h30v267.601562h-30zm0 0",
    fill: "#d4e1f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m84 12h-30c-23.183594.027344-41.972656 18.816406-42 42v2.398438h30v-2.398438c.027344-23.183594 18.816406-41.972656 42-42zm0 0",
    fill: "#d4e1f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m42 390v-42h-30v42c.027344 23.183594 18.816406 41.972656 42 42h30c-23.183594-.027344-41.972656-18.816406-42-42zm0 0",
    fill: "#d4e1f4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m148.199219 384h-44.398438c-3.316406 0-6 2.6875-6 6s2.683594 6 6 6h44.398438c3.316406 0 6-2.6875 6-6s-2.683594-6-6-6zm0 0",
    fill: "#0635c9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m54 0c-29.808594.0351562-53.9648438 24.191406-54 54v336c.0351562 29.808594 24.191406 53.964844 54 54h144c29.808594-.035156 53.964844-24.191406 54-54v-336c-.035156-29.808594-24.191406-53.9648438-54-54zm-42 68.398438h228v267.601562h-228zm186 363.601562h-144c-23.183594-.027344-41.972656-18.816406-42-42v-42h228v42c-.027344 23.183594-18.816406 41.972656-42 42zm42-378v2.398438h-228v-2.398438c.027344-23.183594 18.816406-41.972656 42-42h144c23.183594.027344 41.972656 18.816406 42 42zm0 0",
    fill: "#0635c9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1ae5be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.398438 258h74.402343c3.3125 0 6-2.6875 6-6s-2.6875-6-6-6h-74.402343c-3.3125 0-6 2.6875-6 6s2.6875 6 6 6zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174 258c3.3125 0 6-2.6875 6-6s-2.6875-6-6-6h-43.601562c-3.3125 0-6 2.6875-6 6s2.6875 6 6 6zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.601562 246h-17.800781c-3.316406 0-6 2.6875-6 6s2.683594 6 6 6h17.800781c3.3125 0 6-2.6875 6-6s-2.6875-6-6-6zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.398438 294h14.402343c3.3125 0 6-2.6875 6-6s-2.6875-6-6-6h-14.402343c-3.3125 0-6 2.6875-6 6s2.6875 6 6 6zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 282h-37.601562c-3.3125 0-6 2.6875-6 6s2.6875 6 6 6h37.601562c3.3125 0 6-2.6875 6-6s-2.6875-6-6-6zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.800781 294h79.800781c3.3125 0 6-2.6875 6-6s-2.6875-6-6-6h-79.800781c-3.316406 0-6 2.6875-6 6s2.683594 6 6 6zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 153.699219h14.5v61.121093c0 3.3125 2.6875 6 6 6h99c3.3125 0 6-2.6875 6-6v-61.121093h14.5c2.597656 0 4.898438-1.671875 5.703125-4.140625.804687-2.472656-.070313-5.179688-2.171875-6.707032l-70-50.964843c-2.105469-1.53125-4.957031-1.53125-7.0625 0l-70 50.964843c-2.101562 1.527344-2.976562 4.234376-2.171875 6.707032.804687 2.46875 3.105469 4.140625 5.703125 4.140625zm70-49.539063 51.5625 37.539063h-2.0625c-3.3125 0-6 2.6875-6 6v61.121093h-87v-61.121093c0-3.3125-2.6875-6-6-6h-2.066406zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126 161.792969c10.558594 0 19.121094-8.558594 19.121094-19.121094 0-10.558594-8.5625-19.121094-19.121094-19.121094s-19.121094 8.5625-19.121094 19.121094c.011719 10.554687 8.566406 19.109375 19.121094 19.121094zm0-26.238281c3.933594 0 7.121094 3.1875 7.121094 7.121093 0 3.929688-3.1875 7.121094-7.121094 7.121094-3.933594-.003906-7.121094-3.191406-7.121094-7.125.003906-3.929687 3.191406-7.113281 7.121094-7.117187zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.9d4f654f6d46a79115ebd2a49067765a.svg";
export { ForwardRef as ReactComponent };